module.exports = __webpack_public_path__ + "img/249-democratic-republic-of-congo.3c126e6d.svg";